/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_identity_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link your official Mojang account to synchronize your skin, cape, and profile across launchers.`)
};

const zh_hans1_settings_minecraft_identity_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绑定您的 Mojang 正版账号，跨启动器同步您的皮肤、披风与档案数据。`)
};

const zh_hant1_settings_minecraft_identity_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`綁定您的 Mojang 正版帳號，跨啟動器同步您的皮膚、披風與檔案資料。`)
};

const fr_settings_minecraft_identity_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liez votre compte Mojang officiel pour synchroniser vos skins, capes et profils.`)
};

const de_settings_minecraft_identity_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfen Sie Ihr offizielles Mojang-Konto, um Skins, Capes und Profile synchron zu halten.`)
};

const ja_settings_minecraft_identity_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mojang公式アカウントを連携し、ランチャー間でスキン、マント、プロファイルを同期します。`)
};

const ko_settings_minecraft_identity_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mojang 공식 계정을 연동하여 런처 간에 스킨, 망토 및 프로필 데이터를 동기화합니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_identity_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_identity_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_identity_desc", locale)
	if (locale === "en") return en_settings_minecraft_identity_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_identity_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_identity_desc(inputs)
	if (locale === "fr") return fr_settings_minecraft_identity_desc(inputs)
	if (locale === "de") return de_settings_minecraft_identity_desc(inputs)
	if (locale === "ja") return ja_settings_minecraft_identity_desc(inputs)
	return ko_settings_minecraft_identity_desc(inputs)
};